export default __webpack_public_path__ + "static/media/none.f6e0b217.png";